import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-san",
  "use": "icon-san-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-san\"><defs><style type=\"text/css\"></style></defs><path d=\"M130.255 321.128L512 702.872l381.745-381.745h-763.49z\" p-id=\"1944\" fill=\"#cdcdcd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol